module.exports = __webpack_public_path__ + "img/ESQUINERO.9fbc9eb7.jpg";